// extracted by mini-css-extract-plugin
export default {"table":"index_table_rc-tZ","green":"index_green_wUMdk","more":"index_more_cPIJ4"};